import ParticipantFilesProvider from "../../container/participant/files/context/participantFilesContext";
import ParticipantFilesContainer from "../../container/participant/files/participantFilesContainer";

const ParticipantFiles = (): React.JSX.Element => (
  <ParticipantFilesProvider>
    <ParticipantFilesContainer />
  </ParticipantFilesProvider>
);

export default ParticipantFiles;
